export const ru_testing = {
    Products: 'продуктов<br/> в технологическом<br/> ядре компании',
    unique: 'уникальных рецептур',
    employee: 'сотрудников,<br/>связанных общим делом',
    rubles: 'рублей, выручка компании Мегамикс за 2024 год.',
    mlrd: '36 млрд',
    animal: 'собственных<br/> производственных<br/> площадок<br/> на территории РФ',

    expert: 'экосистема адресных сервисов, консалтинг, экспертная поддержка',
    innovation: 'Инновационные продукты, комплексные и персонализированные решения',
    perspective: 'Перспективная работа в надежной компании',
    growth: 'долгосрочные перспективы роста и  новые возможности для развития бизнеса',
    partner: 'ваш стратегический партнер в сфере кормления',

    controlText: 'контроль качества продукции без компромиссов',
    systemAndControl: 'автоматизированное управление<br/> соответствиями сырья<br/> и готовой продукции',
    leaderText: 'лидер производства кормовых решений',
    ourPremix: 'Российского рынка кормов<br/> на основе наших премиксов',
    dearPartners: 'Дорогие партнеры!',
    weUpdateWebsite: 'Мы обновляем дизайн главной страницы сайта ГК "Мегамикс".',
    helpForUs:
        'Ниже представлены три версии главной страницы сайта megamix.ru. Каждая из них отличается дизайном, структурой и навигацией. Просим вас ознакомиться с описанием и скриншотами (ПК-версия), а затем пройти опрос, выбрав наиболее подходящую версию.',
    startTesting: 'Пройти опрос',
    version: 'Версия',
    titleOfCompany: 'Группа компаний',
    titleOfCompany1: '«Мегамикс»',
    titleOfCompanyNew: 'Мегамикс',
    titleOfCompanyAbout:
        'Крупнейший производитель премиксов, комбикормов и белково-витаминно-минеральных добавок для всех видов сельскохозяйственных животных и птиц',
    cardAboutTestingOneTitle: 'Крупному бизнесу и АПК',
    cardAboutTestingOneDescription:
        'Помогаем агрохолдингам и предприятиям развивать производство с помощью современных кормов, сырья и технологий',
    cardAboutTestingTwoTitle: 'Фермерам и КФХ',
    cardAboutTestingTwoDescription:
        'Работаем с малым и средним хозяйством, предлагаем готовые решения, консультации и удобные сервисы',
    cardAboutTestingThreeDescription: 'Повышаем экономическую эффективность, предлагаем решения, внедряем технологии',
    ourExpertExperience: 'Наш экспертный опыт',
    trading: 'Трейдинг',
    akorm: 'Акорм',
    trading: 'Трейдинг',
    sotrudnichestvo: 'Сотрудничество',
    years: 'лет',
    productsCatalog: 'Каталог продукции',
    productsCatalog_:
        'Каталог продукции ГК МЕГАМИКС включает в себя несколько брендов комбикормов, премиксов и БВМК премиального качества.',
    watchCatalog: 'Смотреть каталог',
    usefulAboutDescription:
        'Узнайте о новых тенденциях и трендах от экспертов и технологов кормовой компании МегаМикс – лидирующей в отрасли производства премиксов и комбикормов на отечественном рынке.',
    sliderTesting: 'Российского рынка кормов на основе наших премиксов',
    thanksTesting: 'Благодарим за просмотр',
    thanksTesting_:
        'Спасибо, что рассмотрели концепты нового дизайна главной страницы ГК "Мегамикс"! Нам важно ваше мнение.',
    next: 'Далее',
    whatMaket: 'Какой макет вам понравился больше?',
    whatKto: 'Кем вы являетесь?',
    whatComment: 'Комментарий (необязательно)',
    variant: 'Вариант',
    clientVariant: 'Клиент ГК "Мегамикс"',
    sotrudnic: 'Сотрудник компании',
    partnerTesting: 'Партнер',
    otherTesting: 'Другое (указать вариант в комментарии)',
    textYouMessage: 'Введите ваше сообщение',
    thankYouTesting: 'Благодарим за отзыв!',
    thankYouTesting_:
        'Вы можете ответить на дополнительные вопросы. Оставлять свои контакты не обязательно, но персонализированный отзыв позволит нам лучше понять ваши рекомендации.',
    yes: 'Да',
    no: 'Нет',
    ofExpertExperience: 'экспертного опыта',
    secondFirstQuestion:
        'Отражают ли представленные варианты род деятельности компании "Мегамикс"? (Да/Нет, поясните в комментарии)',
    secondSecondQuestion: 'Понятна ли вам структура сайта? (Да/Нет, поясните в комментарии)',
    additionalComment: 'Дополнительный комментарий',
    nameAndSurname: 'Имя и фамилия',
    namePlaceholder: 'Иван Иванов',
    consent_with_the_personal_data_processing_policy: 'Согласие с политикой обработки персональных данных',
    feedofus: 'отечественного рынка<br/>кормов на основе наших<br/>премиксов',
    own: 'собственных ',
    createSites: 'производственных<br/>площадок',
    sendTesting: 'Отправить отзыв'
}

export const en_testing = {
    dearPartners: 'Dear Partners!',
    ofExpertExperience: 'of expert experience',
    weUpdateWebsite: 'We are updating the design of the main page of the Megamix Group website.',
    helpForUs:
        'Please help us make it more user-friendly! You will be presented with three design options for the main page of the website. After reviewing them, please answer the questions and share your opinion. It will take no more than five minutes.',
    startTesting: 'Start Test',
    version: 'Version',
    titleOfCompany: 'Group of Companies',
    titleOfCompany1: '“Megamix”',
    titleOfCompanyAbout:
        'The largest manufacturer of premixes, compound feeds, and protein-vitamin-mineral supplements for all types of agricultural animals and birds.',
    cardAboutTestingOneTitle: 'For Large Business and Agriculture',
    cardAboutTestingOneDescription:
        'Effective solutions for agroholdings and industrial enterprises: modern feeding technologies, consulting, and innovative developments.',
    cardAboutTestingTwoTitle: 'For Farmers and Family Farms',
    cardAboutTestingTwoDescription:
        'Support for small and medium-sized farms: ready-made feed solutions, individual approach, and expert consultations.',
    cardAboutTestingThreeDescription:
        'International cooperation: export solutions, advanced technologies, and support at all stages of partnership.',
    ourExpertExperience: 'Our Expert Experience',
    trading: 'Trading',
    own: 'own  ',
    createSites: 'production<br/>sites',
    akorm: 'Feeding',
    sotrudnichestvo: 'Cooperation',
    years: 'years',
    productsCatalog: 'Product Catalog',
    productsCatalog_:
        'The Megamix Group product catalog includes several brands of premium quality compound feeds, premixes, and protein-vitamin-mineral supplements.',
    watchCatalog: 'View Catalog',
    usefulAboutDescription:
        'Learn about new trends and insights from experts and technologists at the Megamix feed company, a leader in the production of premixes and compound feeds in the domestic market.',
    sliderTesting: 'The Russian feed market based on our premixes',
    thanksTesting: 'Thank you for viewing',
    thanksTesting_:
        'Thank you for considering the concepts of the new design for the Megamix Group main page! Your opinion is important to us.',
    next: 'Next',
    whatMaket: 'Which layout did you like the most?',
    whatKto: 'What is your role?',
    whatComment: 'Comment (optional)',
    variant: 'Option',
    clientVariant: 'Client of the Megamix Group',
    sotrudnic: 'Company Employee',
    partnerTesting: 'Partner',
    otherTesting: 'Other (please specify in the comment)',
    textYouMessage: 'Enter your message',
    thankYouTesting: 'Thank you for your feedback!',
    thankYouTesting_:
        'You can answer additional questions. Providing your contact details is not mandatory, but a personalized response will help us better understand your recommendations.',
    yes: 'Yes',
    no: 'No',
    secondFirstQuestion:
        'Do the presented options reflect the activities of the "Megamix" company? (Yes/No, please explain in the comment)',
    secondSecondQuestion: 'Is the website structure clear to you? (Yes/No, please explain in the comment)',
    additionalComment: 'Additional comment',
    nameAndSurname: 'First and Last Name',
    namePlaceholder: 'Ivan Ivanov',
    consent_with_the_personal_data_processing_policy: 'Consent to the personal data processing policy',
    feedofus: 'domestic market<br/>feeds based on our<br/>premixes',
    sendTesting: 'Send feedback'
}

export const cn_testing = {
    dearPartners: '亲爱的合作伙伴！',
    own: '個自己的  ',
    createSites: '生產<br/>繪圖',
    ofExpertExperience: '的专业知识',
    weUpdateWebsite: '我们正在更新“Megamix”集团网站主页的设计。',
    helpForUs:
        '请帮助我们使其更方便！您将看到网站主页的三个设计选项。查看后，请回答问题并分享您的意见。这将花费您不超过五分钟。',
    startTesting: '开始测试',
    version: '版本',
    titleOfCompany: '集团公司',
    titleOfCompany1: '“Megamix”',
    titleOfCompanyAbout: '最大的预混料、复合饲料和蛋白质-维生素-矿物质添加剂的生产商，适用于所有类型的农业动物和鸟类。',
    cardAboutTestingOneTitle: '大型企业和农业',
    cardAboutTestingOneDescription: '为农业集团和工业企业提供有效解决方案：现代饲喂技术、咨询和创新开发。',
    cardAboutTestingTwoTitle: '农民和家庭农场',
    cardAboutTestingTwoDescription: '支持中小型农场：现成的饲料解决方案、个性化服务和专家咨询。',
    cardAboutTestingThreeDescription: '国际合作：出口解决方案、先进技术以及在合作各个阶段的支持。',
    ourExpertExperience: '我们的专家经验',
    trading: '交易',
    feedofus: '的国内市场<br/>饲料以我们的<br/>预混料为基础',
    akorm: '饲料',
    sotrudnichestvo: '合作',
    years: '年',
    productsCatalog: '产品目录',
    productsCatalog_: 'Megamix集团的产品目录包括多个优质复合饲料、预混料和蛋白质-维生素-矿物质添加剂品牌。',
    watchCatalog: '查看目录',
    usefulAboutDescription:
        '了解Megamix饲料公司专家和技术人员提供的新趋势和动态，该公司是国内预混料和复合饲料生产的领导者。',
    sliderTesting: '基于我们预混料的俄罗斯饲料市场',
    thanksTesting: '感谢您的观看',
    thanksTesting_: '感谢您考虑“Megamix”集团主页新设计的概念！您的意见对我们很重要。',
    next: '下一步',
    whatMaket: '您最喜欢哪个设计？',
    whatKto: '您是什么身份？',
    whatComment: '评论（可选）',
    variant: '选项',
    clientVariant: 'Megamix集团客户',
    sotrudnic: '公司员工',
    partnerTesting: '合作伙伴',
    otherTesting: '其他（请在评论中说明）',
    textYouMessage: '输入您的消息',
    thankYouTesting: '感谢您的反馈！',
    thankYouTesting_: '您可以回答额外的问题。提供您的联系信息不是必需的，但个性化的反馈将帮助我们更好地理解您的建议。',
    yes: '是',
    no: '否',
    secondFirstQuestion: '所提供的选项是否反映了“Megamix”公司的业务活动？（是/否，请在评论中说明）',
    secondSecondQuestion: '您是否清楚网站结构？（是/否，请在评论中说明）',
    additionalComment: '额外评论',
    nameAndSurname: '姓名',
    namePlaceholder: '伊万·伊万诺夫',
    consent_with_the_personal_data_processing_policy: '同意个人数据处理政策',
    sendTesting: '提交反馈'
}
